// This file is part of React-Invenio-Deposit
// Copyright (C) 2020 CERN.
// Copyright (C) 2020 Northwestern University.
//
// React-Invenio-Deposit is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

export const INITIAL_STORE_STATE = {
  formState: null,
};

export const STORE_KEYS = Object.keys(INITIAL_STORE_STATE);
